import { type FC } from 'react';

import Text from 'components/_core/Text';

import GuidanceBaseHelp from './Base/GuidanceBaseHelp';
import locales from './locales';

/**
 * Help-like guidance to explain
 * why we need to ask question about company
 */
const GuidanceCompanyProfile: FC = () => {
  const loc = locales.companyProfile;

  return (
    <GuidanceBaseHelp title={loc.title}>
      <Text color="inherit" fontSize="inherit">
        {loc.content}
      </Text>
    </GuidanceBaseHelp>
  );
};

export default GuidanceCompanyProfile;
